import script from "./newBackup2.vue?vue&type=script&setup=true&lang=js"
export * from "./newBackup2.vue?vue&type=script&setup=true&lang=js"

import "./newBackup2.vue?vue&type=style&index=0&id=365d10da&lang=less&scoped=true"

import exportComponent from "D:\\workspace\\payment-system-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-365d10da"]])

export default __exports__